import React from 'react'
import Header from '../../headerone/Main'
import { Breadcrumb } from 'react-bootstrap'
import { Link } from 'react-router-dom';

function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title='test' subtitle="testing" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">
                        <div className="row">
                            <div className="col-lg-5 col-md-12 col-sm-12">
                                <div className="team-img-box">
                                    <Link to="/team-single">
                                        <img src="https://files.iittp.ac.in/images/demo/iit/SG.jpg" alt="img" />
                                    </Link>
                                </div>
                            </div>
                            <div className="text-column col-lg-7 col-md-12 col-sm-12">
                                <div className="s-about-content pl-30 wow fadeInRight" data-animation="fadeInRight" data-delay=".2s" >
                                    <h2>Dr. Sasidhar Gumma</h2>
                                    <p>Professor</p>
                                    <div className="per-info">
                                        <div className="info-text">
                                            <strong>Department</strong>
                                            <p><Link to="/people/faculty/chemical-engineering-department">Chemical Home</Link></p>
                                        </div>
                                        <div className="info-text">
                                            <strong>Personal Webpage</strong>
                                            <p><i className="fal fa-globe" /><Link to="#">Link</Link></p>
                                        </div>
                                        <div className="info-text">
                                            <p>
                                                <i className="fal fa-phone" /> +0877 250 3671
                                            </p>
                                            <p>
                                                <i className="fal fa-envelope" /> s.gumma@iittp.ac.in
                                            </p>
                                        </div>
                                    </div>
                                    <div className='text-dark'>

                                        <h3 className='c-headline'>Areas of Interest </h3>                               
                                        <ul className='ms-3' >
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Metal organic frameworks</li>
                                                <li><i className="fal fa-arrow-alt-circle-right  me-3 c-link" />Adsorption</li>
                                                <li><i className="fal fa-arrow-alt-circle-right  me-3 c-link" />CO2 capture</li>
                                                <li><i className="fal fa-arrow-alt-circle-right  me-3 c-link" />Hydrogen storage</li>
                                                <li><i className="fal fa-arrow-alt-circle-right  me-3 c-link" />Drug delivery</li>
                                                <li><i className="fal fa-arrow-alt-circle-right  me-3 c-link" />Phase equilibrium thermodynamics</li>
                                                <li><i className="fal fa-arrow-alt-circle-right  me-3 c-link" />Monte Carlo simulations </li>
                                            </ul>  

                                        <h3 className='c-headline'>Education</h3>
                                        <ul className='ms-3' >
                                            <li><i className="fal fa-arrow-alt-circle-right  me-3 c-link" />Ph.D., Cleveland State University</li>
                                        </ul>

                                        <h3 className='c-headline'>Latest Publications</h3>
                                            <ul className='ms-3' >
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Loading and release of doxorubicin hydrochloride from iron(III) trimesate MOF and zinc oxidenanoparticle composites, A. Bhattacharjee, M. Purkait, S. Gumma, Dalton Trans., 49, 8755-8763 (2020).</li>
                                            <li className=''><i className="fal fa-arrow-alt-circle-right me-3 c-link" />
                                                  Engineering of Structural and Surface Functional Characteristics of Graphite Oxide Nanosheets by Controlling Oxidation Temperature, P. Das, B. Mandal,
                                                S. Gumma, Appl. Surf. Sci.
                                                  </li>
                                            <p><Link className='c-link ms-5' to="https://www.sciencedirect.com/science/article/abs/pii/S016943321933260X?via%3Dihub" target="_blank" >doi.org/10.1016/j.apsusc.2019.144444 (2019)</Link>.  </p>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />A systematic evaluation of UiO-66 metal organic framework for CO2/N2 separation, S. Edubilli and S. Gumma, Sep. and Purif. Technol., 224, 85–94 (2019).</li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Adsorption Characteristics of Metal Organic Frameworks Containing Coordinatively Unsaturated Metal Sites: Effect of Metal Cations and Adsorbate Properties, P. Mishra, S. Edubilli, B. Mandal and S. Gumma, J. Phys. Chem. C, 118, 6847-6855 (2014).</li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Effect of adsorbent history on adsorption characteristics of MIL-53(Al) metal organic framework, P. Mishra, S. Edubilli, H. Uppara, B. Mandal and S. Gumma, Langmuir, 29, 12162-12167 (2013).
                                                </li>
                                            </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;